import { TABLE_COLUMN_WIDTH } from '../../../components/ModelCompareV4/constants.mjs';
import { wifiProducts } from './product-sets/wifiProductSet.mjs';
import './properties/index.mjs';
import { dimensions } from './properties/dimensions.mjs';
import { wifiTechnology } from './properties/wifiTechnology.mjs';
import { radio6Ghz } from './properties/radio6Ghz.mjs';
import { extendedRangeMode6Ghz } from './properties/extendedRangeMode6Ghz.mjs';
import { dedicatedSpectral } from './properties/dedicatedSpectral.mjs';
import { rfFilteringTechnology } from './properties/rfFilteringTechnology.mjs';
import { antennaType } from './properties/antennaType.mjs';
import { wifiCoverage } from './properties/coverage.mjs';
import { connectedDevices } from './properties/connectedDevices.mjs';
import { weatherproofing } from './properties/weatherproofing.mjs';
import { powerMethodPoe } from './properties/powerMethodPoe.mjs';
import { uplink } from './properties/uplink.mjs';
import { redundantRj45Port } from './properties/redundantRj45Port.mjs';
import { wifiMounting } from './properties/wifiMounting.mjs';
"use strict";
const WifiOverview = {
  properties: [dimensions, wifiTechnology, radio6Ghz, extendedRangeMode6Ghz, dedicatedSpectral, rfFilteringTechnology, antennaType, wifiCoverage, connectedDevices, weatherproofing, powerMethodPoe, uplink, redundantRj45Port, wifiMounting],
  products: wifiProducts,
  columnWidth: TABLE_COLUMN_WIDTH,
  isOverviewPage: true,
  showBadges: true
};
export { WifiOverview };
//# sourceMappingURL=WiFiOverview.mjs.map
